import type { EligibilityStateEnumProto_Value } from "@noom/noom-contracts/noom_contracts/billing/shared";
import type { IneligibleDetailsProto } from "@noom/noom-contracts/noom_contracts/billing/product_catalog/product_eligibility_service";

/**
 * Location segments follow `*_location` naming. Matches `location` as a whole
 * `_`-separated word, so ids such as `*_allocation` are not location.
 */
export function isLocationEctSegment(
  ectSegmentId: string | undefined
): boolean {
  return !!ectSegmentId && /(^|_)location(_|$)/i.test(ectSegmentId);
}

// Evaluate reports a saved home address in an unavailable state both as a
// `*_location` segment and as the INELIGIBLE_REGION_FOR_MED billing reason.
function isLocationDetail(detail: IneligibleDetailsProto): boolean {
  return (
    detail.billingEligibilityFailureReason === "INELIGIBLE_REGION_FOR_MED" ||
    isLocationEctSegment(detail.ectSegmentId)
  );
}

/**
 * INELIGIBLE where every detail is a location segment, so a different
 * shipping address can make the product purchasable.
 */
export function isIneligibleOnlyDueToLocation(
  eligibilityState: EligibilityStateEnumProto_Value | undefined,
  ineligibleDetails: IneligibleDetailsProto[] | undefined
): boolean {
  return (
    eligibilityState === "INELIGIBLE" &&
    !!ineligibleDetails?.length &&
    ineligibleDetails.every(isLocationDetail)
  );
}
